// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__UyVXH","date-txt":"AppointmentSummaryNote_date-txt__CVcgW"};